module.exports = __webpack_public_path__ + "media/images/vip-events-and-experiences-d3c8494d7a83739bb84bc409b1a39c8b.jpg";